import { connect } from 'react-redux';

import { createElement, PropTypes, Component } from 'rlink-react';
import navTo from 'rlink-router/actions/navTo';
import BuildContext from 'rlink-router/BuildContext';

class Redirect extends Component {
  componentDidMount () {
    let {view, params, redirectTo} = this.props;
    redirectTo(this.context.buildContext, view, params);
  }
  render () {
    return null;
  }
}

Redirect.propTypes = {
  view: PropTypes.string,
  params: PropTypes.object,
  redirectTo: PropTypes.func,
};

Redirect.contextTypes = {
  buildContext: PropTypes.instanceOf(BuildContext),
};

function mapDispatchToProps (dispatch) {
  return {
    redirectTo: (buildContext, view, params) => dispatch(navTo(buildContext, {
      view,
      params,
      replaceNavState: true,
    })),
  };
}

export default connect(null, mapDispatchToProps)(Redirect);



// WEBPACK FOOTER //
// ./lib/rlink-router/Redirect.jsx